import { Amplify } from 'aws-amplify';
import { env } from './env';

/**
 * Configure AWS Amplify with Cognito settings
 * This should be called once at application startup
 */
export function configureAmplify() {
  Amplify.configure({
    Auth: {
      Cognito: {
        userPoolId: env.cognito.userPoolId,
        userPoolClientId: env.cognito.clientId,
        loginWith: {
          oauth: {
            domain: `${env.cognito.domain}.auth.${env.cognito.region}.amazoncognito.com`,
            scopes: ['openid', 'email', 'profile'],
            redirectSignIn: [window.location.origin],
            redirectSignOut: [window.location.origin],
            responseType: 'code',
          },
        },
      },
    },
  });
}
